<template>
  <div class="tracking-header">
    <div class="logo mx-auto">
      <router-link :to="mainPage" target="_blank">
        <img :src="logoSrc" :alt="logoAlt" />
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, type ComputedRef } from 'vue'
import { SEARCH_PAGE } from '@/consts/Router'
import { getAppBrand, getBrandQuery } from '@/helpers/Branding'

export default defineComponent({
  name: 'PageHeader',
  setup() {
    const brand = getAppBrand()
    const logoAlt: string = brand === 'charma' ? 'Charma' : brand === 'virea' ? 'Virea' : '21grams'
    const logoSrc: ComputedRef<string> = computed(() => {
      if (brand === 'charma') {
        return new URL('../../../assets/images/charma/charma-logo.png', import.meta.url).href
      }
      if (brand === 'virea') {
        return new URL('../../../assets/images/virea/virea-logo.png', import.meta.url).href
      }
      return new URL('../../../assets/images/logo.svg', import.meta.url).href
    })

    return {
      mainPage: { name: SEARCH_PAGE, query: getBrandQuery() },
      logoSrc,
      logoAlt,
    }
  },
})
</script>
